// Producción y hosting temporal: npm run build · npm run build:hosting-temporal
export const DEPLOY_TARGET = 'production' as 'local' | 'nube' | 'production';
